import { FormattedNumber } from 'react-intl';
import type { CurrencyData } from '../types';
interface FormattedPriceProps {
  amount: number;
  currencyData?: CurrencyData;
}
export function FormattedPrice({
  amount,
  currencyData
}: FormattedPriceProps) {
  // Rate is home-units per target unit, so divide to convert.
  return <FormattedNumber style="currency" currency={currencyData?.currencyName} value={amount / (currencyData?.currencyValue ?? 1)} currencyDisplay="narrowSymbol" minimumFractionDigits={0} maximumFractionDigits={2} />;
}